<template>
  <div>
    <div class="my-2 rounded" id="customer-select" style="border: 1px solid #C8D0DD;">
        <div v-if="listSelectedItem.length" class="p-x-12 p-t-12 name-container">
            <span
                v-for="(item, index) in listSelectedItem"
                :key="index"
                class="border p-1 rounded"
                style="background: #F6F6F6"
            >
                <label class="pr-2 m-0">{{ item.nama }}</label>
                <svg @click="item.isSelected = false" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.529247 1.02876C0.789596 0.768409 1.21171 0.768409 1.47206 1.02876L5.00065 4.55735L8.52925 1.02876C8.7896 0.768409 9.21171 0.768409 9.47206 1.02876C9.73241 1.28911 9.73241 1.71122 9.47206 1.97157L5.94346 5.50016L9.47206 9.02876C9.73241 9.28911 9.73241 9.71122 9.47206 9.97157C9.21171 10.2319 8.7896 10.2319 8.52925 9.97157L5.00065 6.44297L1.47206 9.97157C1.21171 10.2319 0.789596 10.2319 0.529247 9.97157C0.268897 9.71122 0.268897 9.28911 0.529247 9.02876L4.05784 5.50016L0.529247 1.97157C0.268897 1.71122 0.268897 1.28911 0.529247 1.02876Z" fill="#6F7287"/>
                </svg>
            </span>
        </div>
        <SOInputSearch
            id="cari-kasir"
            placeholder="Ketuk untuk menambah kasir"
            value=""
            autocomplete="off"
            :do-searching="cariItem"
            :delay-time="500"
            ref="searchInput"
        />
    </div>
    <div v-if="searcResult.length" class="list-options">
        <p class="m-d-4 f-12 f-c-midgrey f-regular">Hasil Pencarian</p>
        <div class="name-container">
            <template v-for="(item, index) in searcResult">
                <span
                    :key="index"
                    v-if="!item.isSelected"
                    class="border p-1 rounded"
                    style="background: #F6F6F6"
                    @click="addSelected(item)"
                >
                    <label class="m-0 pr-2">{{ item.nama }}</label>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00062 0.833374C9.54374 0.833374 9.98404 1.27367 9.98404 1.81679V8.01663H16.1839C16.727 8.01663 17.1673 8.45692 17.1673 9.00005C17.1673 9.54318 16.727 9.98347 16.1839 9.98347H9.98404V16.1833C9.98404 16.7264 9.54374 17.1667 9.00062 17.1667C8.45749 17.1667 8.0172 16.7264 8.0172 16.1833V9.98347H1.81741C1.27428 9.98347 0.833984 9.54318 0.833984 9.00005C0.833984 8.45692 1.27428 8.01663 1.81741 8.01663H8.0172V1.81679C8.0172 1.27367 8.45749 0.833374 9.00062 0.833374Z" fill="white"/>
                    </svg>
                </span>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import SOInputSearch from "@/so-components/global/input/SOInputSearch.vue";

export default {
    name: 'SOSearchAndSelectItems',
    components: {
        SOInputSearch
    },
    props: [
        'dataSource',
        'value'
    ],
    data() {
        return {
            listData: this.dataSource,
            searcResult: [],
        }
    },
    computed: {
        listSelectedItem() {
            return this.listData.filter((item) => {
                return item.isSelected
            })
        },
        listAvailableItem() {
            return this.listData.filter((item) => {
                return !item.isSelected
            })
        },
        inputVal: {
            get() {
                return this.value;
            },
            set() {
                this.$emit('input', this.listSelectedItem);
            }
        },
    },
    methods: {
        cariItem(key) {
            console.log(key);
            if (key) {
                this.searcResult = []
                this.listData.forEach(element => {
                    if (element.nama.toLowerCase().includes(key)) {
                        this.searcResult.push(element)
                    }
                });
            } else {
                console.log('kosong');
                this.searcResult = []
            }
        },
        addSelected(item) {
            item.isSelected = true
            this.$emit('addOptions', this.listSelectedItem)
        }
    }
}
</script>

<style scoped>
.name-container{
    display: flex;
    flex-flow: wrap;
    gap: 8px;
    overflow: auto;
    max-height: 150px;
}
#customer-select >>> .form-group div input{
    border: none;
}
#customer-select >>> .form-group div input:focus{
    box-shadow: none;
}
</style>